import React, { useState, useContext } from 'react'

import { useIntl } from 'react-intl'
import { UserLoan } from '@matech/thebigpos-sdk'

import SplitButton, {
	SplitButtonMenuItem,
} from '../Button/SplitButton'
import ModalAddCoBorrower, {
	ModalAddCoBorrowerProps,
} from '../modals/ModalAddCoBorrower'
import {
	LanguageContext,
	LanguageContextProps,
} from '../../contexts/LanguageContext'
import useUser from '../../hooks/useUser'
import { useSiteConfig } from '../../hooks/useSiteConfig'
import { useLoanContext } from '../../contexts/LoanContext'

type LoanUsersTablesTitleActionsProps = {
	handleOpenShareLoanModal?: () => void
}

const LoanUsersTablesTitleActions = ({
	handleOpenShareLoanModal,
}: LoanUsersTablesTitleActionsProps) => {
	const { formatMessage } = useIntl()
	const { siteConfig } = useSiteConfig()
	const { user, isLoanAdmin } = useUser()
	const { loanData, loan } = useLoanContext()
	const { locale } = useContext<LanguageContextProps>(LanguageContext)

	const canAddCoBorrower = siteConfig?.enabledServices?.addCoBorrower
	const canShareLoan = isLoanAdmin && !!handleOpenShareLoanModal

	const [
		isAddCoBorrowerModalVisible,
		setIsAddCoBorrowerModalVisible,
	] = useState(false)

	const handleOpenAddCoBorrowerModal = () =>
		setIsAddCoBorrowerModalVisible(true)

	const handleCloseAddCoBorrowerModal = () =>
		setIsAddCoBorrowerModalVisible(false)

	const actionsItems: SplitButtonMenuItem[] = [
		canAddCoBorrower && {
			label: formatMessage({
				id: 'add_coborrower_form.add_a_coborrower',
			}),
			onClick: handleOpenAddCoBorrowerModal,
		},
		canShareLoan && {
			label: formatMessage({
				id: 'share_loan.title',
			}),
			onClick: handleOpenShareLoanModal,
		},
	].filter((item) => !!item)

	const [mainAction, ...menuItems] = actionsItems

	if (!mainAction) return null

	return (
		<>
			<SplitButton
				label={mainAction.label}
				onClick={mainAction.onClick}
				buttonGroupProps={{
					disabled: loan?.isLocked,
				}}
				menuItems={menuItems}
			/>
			{canAddCoBorrower && (
				<ModalAddCoBorrower
					blacklist={loanData?.userLoans?.map(
						(borrower: UserLoan) => borrower?.user?.email
					)}
					role={user?.role}
					visible={isAddCoBorrowerModalVisible}
					onClose={handleCloseAddCoBorrowerModal}
					setVisible={undefined}
					siteConfig={siteConfig}
					locale={locale as ModalAddCoBorrowerProps['locale']}
				/>
			)}
		</>
	)
}

export default LoanUsersTablesTitleActions
